module.exports = __webpack_public_path__ + "static/media/mail-vector.12f05922.jpg";